import {PostExamsConfirm} from 'domain/usecases';
import {RemotePostExamsConfirm} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

export const makePostExamBooking = (): PostExamsConfirm => {
	const isExamBookingConfirmV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_BOOKING_EXAMS_CONFIRM_V3,
	);

	const endpoint = isExamBookingConfirmV3Enabled
		? BookingFlowEndPoints.examBookingConfirmV3
		: BookingFlowEndPoints.examBookingConfirm;

	return new RemotePostExamsConfirm(makeBFFApiUrl(endpoint), makeAuthorizeHttpClientDecorator());
};
